import React from 'react';
import classNames from 'classnames';
import { Button } from '@benzinga/core-ui';
import { checkDeviceType } from '@benzinga/device-utils';
import { useHydrate } from '@benzinga/hooks';

export interface ReadInAppButtonProps {
  className?: string;
  url?: string;
}

const appleAppStoreLink = 'https://apps.apple.com/us/app/benzinga-financial-news-data/id688949481';
const googlePlayStorelink = 'https://play.google.com/store/apps/details?id=com.benzinga.app';

export const ReadInAppButton: React.FC<ReadInAppButtonProps> = ({ className = '' }) => {
  const isApple = useHydrate(checkDeviceType().isApple(), false);

  const linkToStore = isApple ? appleAppStoreLink : googlePlayStorelink;
  const dataAction = isApple ? 'Download on Apple App Store Click' : 'Download on Google Play Store Click';

  return (
    <a
      className={classNames('read-in-app-button-container flex h-10 items-center', className)}
      data-action={dataAction}
      href={linkToStore}
      rel="noreferrer"
      target="_blank"
    >
      <Button className="read-in-app-button h-[35px] px-5" variant="primary">
        Read in App
      </Button>
    </a>
  );
};

export default ReadInAppButton;
